const detail = [
  {
    path: '/vacation/management/detail/current/:id',
    component: () => import('@/page/vacation/detail/Current.vue'),
    name: 'current',
    meta: {
      name: '상세페이지/사용 연차',
      isActive: false,
      isBread: false,
    },
  },
  {
    path: '/vacation/management/detail/allow/:id',
    component: () => import('@/page/vacation/detail/Allow.vue'),
    name: 'allow',
    meta: {
      name: '상세페이지/지급 휴가',
      isActive: false,
      isBread: false,
    },
  },
];

export default detail;
